import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { CognitivePsychosocialQuestionnaireItem } from './questionnaire'

export const COGNITIVE_PSYCHOSOCIAL_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [CognitivePsychosocialQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_COMMUNICATION_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [CognitivePsychosocialQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_COGNITIVE_ASSESSMENT]:
    QuestionnaireAnswerType.STRING,
  [CognitivePsychosocialQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_HISTORY_SUBSTANCE_ABUSE]:
    QuestionnaireAnswerType.STRING,
  [CognitivePsychosocialQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_SUBSTANCE_ABUSE_NOTES]:
    QuestionnaireAnswerType.STRING,
  [CognitivePsychosocialQuestionnaireItem.MEDICAL_BACKGROUND_COGNITIVE_PSYCHOSOCIAL_DEV_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
